import LockPersonIcon from '@mui/icons-material/LockPerson';
import ToggleOnIcon from '@mui/icons-material/ToggleOn';
import { lazy } from 'react';

import { Path } from '.';
import { FeatureTab } from '../../views/dm-feature-access/constants';

const dmPaths: Path[] = [
  {
    path: '/capability',
    name: 'Capability',
    icon: <LockPersonIcon />,
    View: lazy(
      () =>
        import(
          '../../views/dm-capability' /* webpackChunkName: "view_device-management" */
        )
    ),
    childViews: [
      {
        name: 'Model Detail',
        hide: true,
        path: '/:modelId',
        View: lazy(
          () =>
            import(
              '../../views/dm-capability/ModelsDetails' /* webpackChunkName: "view_entity_signup_detail" */
            )
        ),
      },
    ],
  },
  {
    path: '/feature-access',
    name: 'Feature Access',
    icon: <ToggleOnIcon />,
    View: lazy(
      () =>
        import(
          '../../views/dm-feature-access' /* webpackChunkName: "view_device-management" */
        )
    ),
    childViews: [
      {
        name: 'Group Detail',
        hide: true,
        path: '/groups/:groupId',
        backHash: FeatureTab.groups,
        View: lazy(
          () =>
            import(
              '../../views/dm-feature-access/GroupDetail' /* webpackChunkName: "view_device-management" */
            )
        ),
      },
      {
        name: 'Feature Detail',
        hide: true,
        path: '/:featureKey',
        View: lazy(
          () =>
            import(
              '../../views/dm-feature-access/Detail' /* webpackChunkName: "view_device-management" */
            )
        ),
      },
    ],
  },
];

export default dmPaths;
